import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Учет выдачи идентификационных карт")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, "Муниципальное образование", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Пункт выдачи карт", -1)
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = { class: "text-rigth" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, "Итого по категориям:", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "font-weight-bold text-center" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "text-center",
    style: {"border-top":"0"}
  }, "Нет данных")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

import { computed, ref, Ref } from 'vue'
import {
  cardIssuePointGetAddress,
  CitizenCategory,
  IssuanceCardsStat,
  IssuanceCardsStatsService,
  MunicipalEntitiesService,
  citizenCategoryShorthand,
  citizenCategoryName,
  CardIssuePointsService,
  enumGetKeys,
  Paging,
  AppAuthService,
  Permissions,
} from '@prodcard/core'
import { createCtx, handleError, useWatcherSavedRef } from '../../../../helpers'
import FilterBox, { SearchParams } from './FilterBox.vue'
import { Pagination } from '../../../../components'
import { usePaginator, Paginator, useAuthPermissions } from '../../../../mixins'
import { toArray } from 'lodash'
import { Workbook } from 'exceljs'
import { createSheetIssuanceCardsStats } from './createSheetIssuanceCardsStats'
import { saveWorkbook } from '../../../../common'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssuanceCardsStatsListPage',
  props: {
    issuanceCardsStatsService: {},
    municipalEntitiesService: {},
    cardIssuePointsService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;


const groupedByCIP: Ref<IssuanceCardsStat[]> = ref([])
const groupedByME: Ref<IssuanceCardsStat[]> = ref([])
const loading = ref(false)
const loadingTableToDownload = ref(false)

const { currentMunicipalEntityId, hasPermissions } = useAuthPermissions(props.authService)
const hasView = computed(() => hasPermissions(Permissions.ISSUANCE_CARDS_STATS_VIEW))
const hasMeView = computed(() => hasPermissions(Permissions.ME_ISSUANCE_CARDS_STATS_VIEW))

const { paginator, count, getPageCount, resetPage } = usePaginator('issuanceCardsStatsPaginator')
const citizenCategoryList = enumGetKeys(CitizenCategory)

const searchParams: Ref<SearchParams> = useWatcherSavedRef('issuanceCardsStatsSearchParams', {
  year: undefined,
  month: undefined,
  municipalEntityId: !hasView.value && hasMeView.value ? currentMunicipalEntityId.value : undefined,
  cardIssuePointId: undefined,
})

const update = (paginator: Paginator, filter: SearchParams) => {
  handleError(async () => {
    const from = (paginator.page - 1) * paginator.per
    const { resGroupedByCIP, resGroupedByME } = await fetchData(filter, { from, count: paginator.per })

    groupedByCIP.value = resGroupedByCIP.items
    count.value = resGroupedByCIP.total
    groupedByME.value = resGroupedByME
  }, loading)
}

const fetchData = async (filter: SearchParams, paging: Paging) => {
  const { groupedByCIP, groupedByME } = await props.issuanceCardsStatsService.formReport(createCtx(), {
    filter: {
      ...filter,
      month: filter.month === null ? undefined : filter.month,
      year: filter.year === null ? undefined : filter.year,
    },
    paging,
  })

  return { resGroupedByCIP: groupedByCIP, resGroupedByME: groupedByME }
}

const updateSearchParams = (newSearchParams: SearchParams) => {
  searchParams.value = newSearchParams
  resetPage()
  update(paginator.value, searchParams.value)
}

const fullSumIssuanceCardsStats = (issuanceCardsStats: IssuanceCardsStat[]): number => {
  return issuanceCardsStats.reduce((acc, curr) => {
    toArray(curr.values).forEach(item => {
      acc += item
    })
    return acc
  }, 0)
}

const downloadTable = (filter: SearchParams) => {
  handleError(async () => {
    const workbook = new Workbook()
    const { resGroupedByCIP, resGroupedByME } = await fetchData(filter, {})
    createSheetIssuanceCardsStats(workbook, 'Учет выдачи идентификационных карт', {
      groupedByCIP: resGroupedByCIP.items,
      groupedByME: resGroupedByME,
    })
    await saveWorkbook(workbook, 'Учет_выдачи_идентификационных_карт')
  }, loadingTableToDownload)
}

update(paginator.value, searchParams.value)

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(FilterBox, {
        "default-search-params": _unref(searchParams),
        "card-issue-points-service": _ctx.cardIssuePointsService,
        "municipal-entities-service": _ctx.municipalEntitiesService,
        loading: loading.value,
        readonlyMe: !hasView.value && hasMeView.value,
        class: "my-5",
        onUpdate: updateSearchParams
      }, null, 8, ["default-search-params", "card-issue-points-service", "municipal-entities-service", "loading", "readonlyMe"]),
      _createVNode(_component_v_card, {
        elevation: "0",
        loading: loading.value,
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, { hover: "" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _hoisted_3,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: citizenCategory,
                      title: _unref(citizenCategoryName)(citizenCategory as CitizenCategory),
                      class: "text-center"
                    }, _toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory as CitizenCategory)), 9, _hoisted_4))
                  }), 128))
                ])
              ]),
              (groupedByME.value.length > 0 || groupedByCIP.value.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByME.value, (me) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: me.municipalEntity.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_6, _toDisplayString(me.municipalEntity.name), 1),
                          _hoisted_7,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: citizenCategory,
                              class: "font-weight-bold text-center"
                            }, _toDisplayString(me.values[citizenCategory as CitizenCategory]), 1))
                          }), 128))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByCIP.value.filter(item => item.municipalEntity.id === me.municipalEntity.id), (cip) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: cip.cardIssuePoint.id
                          }, [
                            _hoisted_8,
                            _createElementVNode("td", _hoisted_9, [
                              _createTextVNode(_toDisplayString(_unref(cardIssuePointGetAddress)(cip.cardIssuePoint)) + " ", 1),
                              (cip.cardIssuePoint.comment)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    text: cip.cardIssuePoint.comment,
                                    activator: "parent",
                                    location: "top left",
                                    "max-width": "350px"
                                  }, null, 8, ["text"]))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: citizenCategory,
                                class: "text-center"
                              }, _toDisplayString(cip.values[citizenCategory as CitizenCategory]), 1))
                            }), 128))
                          ]))
                        }), 128))
                      ], 64))
                    }), 128)),
                    (groupedByME.value.length > 1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: citizenCategory,
                              class: "font-weight-bold text-center"
                            }, _toDisplayString(groupedByME.value.reduce((acc, curr) => (acc += curr.values[citizenCategory as CitizenCategory]), 0)), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (groupedByCIP.value.length > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                          _createElementVNode("td", {
                            colspan: _unref(citizenCategoryList).length + 1,
                            class: "font-weight-bold"
                          }, "Общий итог:", 8, _hoisted_13),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(fullSumIssuanceCardsStats(groupedByME.value)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (!loading.value)
                  ? (_openBlock(), _createElementBlock("tfoot", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Pagination), {
            modelValue: _unref(paginator),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
              _cache[1] || (_cache[1] = ($event: any) => (update($event, _unref(searchParams))))
            ],
            "page-count": _unref(getPageCount),
            disabled: loading.value || _unref(getPageCount) === 0,
            class: "mt-5"
          }, null, 8, ["modelValue", "page-count", "disabled"])
        ]),
        _: 1
      }, 8, ["loading", "disabled"]),
      (_unref(hasPermissions)(_unref(Permissions).ISSUANCE_CARDS_STATS_TABLE_EXPORT))
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "mt-5",
            color: "primary",
            variant: "outlined",
            "prepend-icon": "mdi-download-outline",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadTable(_unref(searchParams)))),
            loading: loadingTableToDownload.value,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Скачать ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})